export default "__VITE_ASSET__DKCCYZqD__"